/** Analytics dashboard design tokens (mockup-aligned) */
export const analyticsColors = {
  pageBg: '#FAF7F4',
  cardBg: '#FFFFFF',
  cardBorder: '#FDF0F1',
  title: '#1A1C2E',
  subtitle: '#8A8A8A',
  rankBg: '#FDF0F1',
  rankText: '#EE3750',
  toggleBg: '#FDF0F1',
  toggleActiveBg: '#FFFFFF',
  toggleActiveBorder: '#EE3750',
  metricLabel: '#8A8A8A',
  metricValue: '#1A1C2E',
  growthPositive: '#28A745',
  growthNegative: '#DC2626',
  chartPrimary: '#EE3750',
  chartPrimaryMuted: '#FDF0F1',
  chartGrid: '#FDF0F1',
  funnelDark: '#EE3750',
  funnelMid: '#EE3750',
  funnelLight: '#FDF0F1',
};

export const analyticsPanelSx = {
  bgcolor: analyticsColors.cardBg,
  border: `1px solid ${analyticsColors.cardBorder}`,
  borderRadius: '16px',
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.04)',
  p: { xs: 2, sm: 3 },
};

export const analyticsChartCardSx = {
  height: '100%',
  bgcolor: analyticsColors.cardBg,
  border: `1px solid ${analyticsColors.cardBorder}`,
  borderRadius: '12px',
  boxShadow: 'none',
  display: 'flex',
  flexDirection: 'column',
};

export const salesChartHeaderSx = {
  px: 2.5,
  pt: 2.5,
  pb: 0,
};

export const salesChartTitleSx = {
  fontSize: '0.9375rem',
  fontWeight: 600,
  color: analyticsColors.title,
  lineHeight: 1.3,
};

export const salesChartSubtitleSx = {
  fontSize: '0.8125rem',
  color: analyticsColors.subtitle,
  mt: 0.25,
};

export const salesChartBaseOptions = {
  chart: {
    background: 'transparent',
    toolbar: { show: false },
    fontFamily: 'inherit',
  },
  grid: {
    borderColor: analyticsColors.chartGrid,
    strokeDashArray: 4,
    xaxis: { lines: { show: true } },
    yaxis: { lines: { show: true } },
  },
  xaxis: {
    labels: {
      style: {
        colors: analyticsColors.subtitle,
        fontSize: '11px',
      },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    labels: {
      style: {
        colors: analyticsColors.subtitle,
        fontSize: '11px',
      },
    },
  },
};
